import * as React from "react";
import { times } from "lodash";
import "./MasonryGallery.css";
import MasonryGallery from "./MasonryGallery";
import { SkeletonImage } from "src/share/components/SkeletonImage/SkeletonImage";

const MasonrySkeleton = () => (
  <div>
    <div className="skeleton-transition" />
    <MasonryGallery>
      {times(24, i => <SkeletonImage key={i} />)}
    </MasonryGallery>
  </div>
);

export default MasonrySkeleton;

